import {
    SET_MARKERS,
    ADD_MARKER,
    REMOVE_MARKER
} from './Types';
import { Marker } from './markersTypes';

export const setMarkers = (markers:Marker[]) => {
    return ({
        type: SET_MARKERS,
        markers
    });
};

export const addMarker = (marker:Marker) => ({
    type: ADD_MARKER,
    marker
});

export const removeMarker = (id:number) => ({
    type: REMOVE_MARKER,
    id
});